"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const QCloseBox_1 = __importDefault(require("components/QCloseBox"));
const CategoryReviewCard_1 = __importDefault(require("components/CategoryReviewCard"));
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const AmountField_1 = require("components/QuickenControls/AmountField");
const editBudgetHelpers_1 = require("components/Budgets/EditBudgetsDialog/editBudgetHelpers");
const subComponents_1 = require("./subComponents");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
// @ts-expect-error: Only a void function can be called with the 'new' keyword.
const BudgetAddCategory = ({ onAdd, onClose, accountIds, currency = new immutable_1.Set(), categoryIds }) => {
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)(null);
    const [currentAmount, setCurrentAmount] = (0, react_1.useState)(0);
    const [monthlyAverage, setMonthlyAverage] = (0, react_1.useState)(0);
    const { classes } = useStyles();
    const internalOnChange = (e) => {
        if (Number(e.target.value) !== Number(currentAmount))
            setCurrentAmount(Number(e.target.value));
    };
    const internalOnAdd = () => {
        onAdd({ coa: selectedCategory, amount: currentAmount });
    };
    const onCatChange = (coa) => {
        if (!chart_of_accounts_1.chartOfAccountsUtils.coasAreEqual(coa, selectedCategory))
            setSelectedCategory(chart_of_accounts_1.chartOfAccountsTypes.mkChartOfAccount(coa));
    };
    const onSubmit = (e) => {
        if (selectedCategory) {
            onAdd({ coa: selectedCategory, amount: Number(e.target.value) });
            onClose();
        }
    };
    const duplicateCategory = (0, react_1.useMemo)(() => selectedCategory ? categoryIds.includes(selectedCategory.id) : false, [selectedCategory, categoryIds]);
    return (<Dialog_1.default maxWidth="md" open onClose={onClose} classes={{ paperWidthMd: classes.dialogRoot }}>
      <QCloseBox_1.default onClose={onClose} id="add-to-budget-close-button"/>
      <subComponents_1.TitleHeader classes={classes}/>
      <Divider_1.default classes={{ root: classes.dividerRoot }}/>

      <div className={classes.fieldsContainer}>
        <subComponents_1.CategoryWrappedField catFieldProps={{
            value: selectedCategory,
            onChange: onCatChange,
            // filterFn: catFilterFn,
            numPopularCats: 10,
            InputProps: {
                placeholder: 'Select a Category',
            },
        }}/>
        <subComponents_1.AmountWrappedField currentAmount={currentAmount} classes={{ inputField: classes.amountInputStyle }} onBlur={(e) => internalOnChange(e)} onSubmit={onSubmit} currency={currency}/>
      </div>

      <Divider_1.default classes={{ root: classes.dividerRoot }}/>

      {selectedCategory &&
            <>
          <CategoryReviewCard_1.default coa={selectedCategory} accountIds={accountIds} numMonths="3_MONTHS_PRIOR" classes={{ transactionList: classes.categoryReviewTxList, root: classes.categoryReviewCardRoot }} onAverageCalc={setMonthlyAverage} currency={currency} onSetValueFromGraph={(amt) => setCurrentAmount((0, editBudgetHelpers_1.setAmountSign)(Number(Number(amt).toFixed(0)), selectedCategory))}/>
          <div className={classes.monthlyAverage}>
            <ButtonBase_1.default focusRipple onClick={() => setCurrentAmount((0, editBudgetHelpers_1.setAmountSign)(Number(Number(monthlyAverage).toFixed(0)), selectedCategory))}>
              <Typography_1.default variant="h6">
                {`Monthly Average: ${(0, AmountField_1.formatNumber)((0, editBudgetHelpers_1.setAmountSign)(monthlyAverage, selectedCategory), currency)}`}
              </Typography_1.default>
            </ButtonBase_1.default>
          </div>

        </>}

      <subComponents_1.ButtonArea onAdd={internalOnAdd} onClose={onClose} disableSubmit={selectedCategory === null || duplicateCategory}/>
    </Dialog_1.default>);
};
exports.default = BudgetAddCategory;
